import { Point, Container } from 'pixi.js'
import gsap from 'gsap'
import Item from '@/scripts/canvas/Item'
import { ANIMATION, ACTIVITY_INFO_BOX_TOUCH_SHIFT_OFFSETS } from '@/scripts/config/constants'
import { isArchive, ITEM_DELAY } from '@/scripts/config/settings'
import activityInfoBox from '@/scripts/ui/activityInfoBox'
import Analytics, { ACTION_ACTIVITY_HOVER, ACTION_ACTIVITY_OPEN } from '@/scripts/analytics'
import audioManager from '@/scripts/audio/audioManager'
import { centerStageOnItem } from './stagePositioning'

export function showBullets(items: Item[], doShow = true): void {
  items.forEach((item, i) =>
    gsap.delayedCall(ANIMATION.BULLET_STAGGER_DELAY * i, () => item.itemBullet.displayBullet(doShow)),
  )
}

export function openActivityInfoBox(item: Item, playSound: boolean = false): void {
  if (isArchive || !item.itemBullet) return

  // Only hide bullet hover state if not a touch event (touch events show phase 2 for 2 seconds)
  if (!playSound) {
    item.itemBullet.setHoverState(false)
  }

  const provider = () => {
    const p = item.parent as Container | undefined
    if (!p) return new Point(0, 0)

    const beak = item.getBeakPosition()
    const beakWorld = p.toGlobal(new Point(beak.x, beak.y))

    const canvasEl = document.querySelector('.canvas-container canvas') as HTMLCanvasElement | null
    const r = canvasEl?.getBoundingClientRect()
    if (!r) return beakWorld

    let viewportPoint = new Point(r.left + beakWorld.x, r.top + beakWorld.y)

    // For touch devices in desktop mode, apply custom offsets if configured for this day
    if (playSound) {
      const day = item.activity.day
      const customOffsets = ACTIVITY_INFO_BOX_TOUCH_SHIFT_OFFSETS[day]

      if (customOffsets) {
        if (customOffsets.left !== undefined) {
          viewportPoint.x -= customOffsets.left
        }
        if (customOffsets.right !== undefined) {
          viewportPoint.x += customOffsets.right
        }
        if (customOffsets.top !== undefined) {
          viewportPoint.y -= customOffsets.top
        }
        if (customOffsets.bottom !== undefined) {
          viewportPoint.y += customOffsets.bottom
        }
      }
    }

    return viewportPoint
  }

  activityInfoBox.showWithProvider(item.activity, provider)

  // Only play sound when opening from tap (tablet in desktop mode)
  if (playSound) {
    audioManager.playItemSfx(item.id, null)
  }

  Analytics.sendCustomEvent(ACTION_ACTIVITY_OPEN, item.activity.linkHash)
}

export function openMobileActivityInfoBox(
  item: Item,
  itemOverDelayedCall: { current: gsap.core.Tween | undefined },
): void {
  activityInfoBox.show(item.activity, new Point(0, 0))
  item.setHoverState(true)

  Analytics.sendCustomEvent(ACTION_ACTIVITY_HOVER, item.activity.linkHash)
  itemOverDelayedCall.current = gsap.delayedCall(ITEM_DELAY / 1000, () => {
    audioManager.playItemSfx(item.id, null)
  })

  Analytics.sendCustomEvent(ACTION_ACTIVITY_OPEN, item.activity.linkHash)
  centerStageOnItem(item)
}
